import * as Utils from '@js/modules/utils';

// Array must be sorted
const getClosestValue = (array, value) => {
    if (Utils.isEmpty(array)) return;

    let lo = -1;
    let hi = array.length;
    while (hi - lo > 1) {
        const mid = Math.round((lo + hi) / 2);
        if (array[mid] <= value) {
            lo = mid;
        } else {
            hi = mid;
        }
    }
    if (array[lo] === value) hi = lo;

    const lowDiff = Math.abs(array[lo] - value);
    const highDiff = Math.abs(array[hi] - value);

    if (lowDiff < highDiff) {
        return array[lo];
    } else {
        return array[hi];
    }
};

const GraphMapModule = {
    _graphModel: {
        markerViewPointPopup: undefined
    },

    showViewPointAtDistance(distance, elevation) {
        if (Utils.isEmpty(this._model.pointsByDistanceTraveled)) {
            return;
        }

        const pointDistances = Object.keys(this._model.pointsByDistanceTraveled);

        let distanceKey = getClosestValue(pointDistances, Math.floor(distance));

        if (!distanceKey && parseFloat(distance) > parseFloat(pointDistances.last())) {
            distanceKey = pointDistances.last();
        }

        const point = this._model.pointsByDistanceTraveled[distanceKey];
        if (point) {
            this.showViewPointAtPoint(point, elevation);
        }
    },

    showViewPointAtPoint(latLng, content) {
        if (Utils.isEmpty(this._model.map)) {
            return;
        }

        const popupContent = `<div class="elevation-popup-content text-white rounded-xl">${content}</div>`;

        if (!this._graphModel.markerViewPointPopup) {
            this._graphModel.markerViewPointPopup = this.buildPopup({
                className: 'elevation-popup',
                closeButton: false,
                closeOnClick: true,
                offset: [0, 0]
            })
                .addTo(this._model.map);
        }

        this._graphModel.markerViewPointPopup
            .setHTML(popupContent)
            .setLngLat(latLng);
    },

    removeViewPointMarker() {
        if (Utils.isPresent(this._graphModel.markerViewPointPopup) && Utils.isPresent(this._model.map)) {
            this._graphModel.markerViewPointPopup.remove();
            this._graphModel.markerViewPointPopup = null;
        }
    },
};

export default GraphMapModule;
